import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import AdminUserStore from '@/store/AdminUserStore.js';
import SelectedRecordListStore from '@/store/SelectedRecordListStore.js';

Vue.use(Vuex);
const set = (property) => (store, payload) => (store[property] = payload);

const store = new Vuex.Store({
  state: {
    config: {},
    models: [],
    search: '',
    sdk: null,
    awsExports: null,
    languages: [],
    selectedLanguage: 'en_US',
    snackbar: { message: null, type: null, show: false },
    navigation: {
      title: null
    },
    viewReload: false,
    // cognito
    email: '',
    isLoading: false,
    isReady: false,
    isSessionLoaded: false,
    password: '',
    workspace: 'unpublished' // TODO: should come from systemConfig,
  },
  getters: {
    currentWorkspace: (state) => {
      return state.workspace;
    },
    workspaceBucket: (state) => {
      return state.awsExports.s3_bucket_prefix + state.workspace;
    }
  },
  mutations: {
    setSelectedLanguage(state, language) {
      state.selectedLanguage = language;
    },
    setSearch(state, search) {
      state.search = search;
    },
    initSdk(state, sdk) {
      state.sdk = sdk;
    },
    setAWSExports(state, awsExports) {
      state.awsExports = awsExports;
    },
    setModels(state, models) {
      state.models = models;
    },
    setConfig(state, config) {
      state.config = config;
      state.languages = config.languages;
      state.datatypes = config.datatypes || {};
      state.selectedLanguage = config.languages[0];
    },
    setWorkspace(state, workspace) {
      state.workspace = workspace;
    },
    setSnackbar(state, { message, type }) {
      state.snackbar.message = message;
      state.snackbar.type = type;
      state.snackbar.show = true;
    },
    changeSnackbarStatus(state, status) {
      state.snackbar.show = status;
    },
    clearSnackbar(state) {
      state.snackbar.message = null;
      state.snackbar.show = false;
      state.snackbar.type = null;
    },
    addModelDataListToModel(state, { modelName, modelDataList }) {
      state.models[modelName]['modelDataList'] = modelDataList;
    },
    setNavigationTitle(state, title) {
      state.navigation.title = title;
    },
    setViewReload(state, value) {
      state.viewReload = value;
    },
    // cognito
    setEmail: set('email'),
    setIsSessionLoaded: set('isSessionLoaded'),
    setIsLoading: set('isLoading'),
    setPassword: set('password'),
    setUser: set('user')
  },
  actions: {},
  modules: { AdminUserStore, SelectedRecordListStore },
  plugins: [
    new VuexPersistence({
      key: 'AdminUserStore',
      modules: ['AdminUserStore']
    }).plugin
  ]
});

export default store;
